/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackAnswerListItemViewModel } from "../types/FeedbackAnswerListItemViewModel.ts";

export const feedbackAnswerListItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  feedbackId: z.optional(z.number().int()),
  personId: z.optional(z.number().int()),
  personName: z.string().nullish(),
  answerNumber: z.optional(z.number().int()),
  answer: z.string().nullish(),
  comment: z.string().nullish(),
  answerDate: z.string().datetime().nullish(),
}) as unknown as ToZod<FeedbackAnswerListItemViewModel>;
